<template>
    <div id="test-autocomplete-page">
        #{{ $route.params }}
        <hr />
        <div v-if="datafields">
            <description-editor
                v-model="content"
                :datafields="datafields"></description-editor>
            <hr />
            {{ trans('pages.test_autocomplete.parent_value') }}: {{ content }}
        </div>
        <div id="loader-spinner" v-else>
            <img src="images/ajax-loader.gif" />
            <span id="loader-text">{{ trans('pages.test_autocomplete.loading_product_type') }}</span>
        </div>
    </div>
</template>
<style>
#test-autocomplete-page .loader-spinner {
    margin-left: auto;
    margin-right: auto;
}
</style>
<script>
import DescriptionEditor from '../components/productTypes/DescriptionEditor';
import productTypeApi from '../api/productType';
import localization from '../mixins/localization';

export default {
    components: {
        DescriptionEditor,
    },
    mixins: [localization],
    data() {
        return {
            content: '',
            datafields: null,
        };
    },
    mounted() {
        const productTypeId = this.$route.params.id;
        productTypeApi.fetchDataFields(productTypeId).then((response) => {
            this.datafields = response.data.data;
        });
    },
};
</script>
